import { Routes } from '@angular/router';
import { AuthLayoutComponent } from '@core/components/layout/auth-layout/auth-layout.component';
import { ClientPageLayoutComponent } from '@core/components/layout/client/client-page-layout/client-page-layout.component';
import { PageLayoutComponent } from '@core/components/layout/page-layout/page-layout.component';
import { RootSkeletonLayoutComponent } from '@core/components/layout/root-skeleton-layout/root-skeleton-layout.component';
import { appRedirectGuard } from '@core/guards/app-redirect/app-redirect.guard';
import { clientSetupResolver } from '@core/services/client-setup/client-setup.resolver';
import { HomeComponent } from '@features/home/pages/home/home.component';
import { RootHomeSkeletonComponent } from '@features/home/pages/root-home-skeleton/root-home-skeleton.component';
import { clientMetaResolver } from '@features/home/resolvers/client-meta/client.meta.resolver';
import { PageNotFoundComponent } from '@shared/pages/page-not-found/page-not-found.component';

export const routes: Routes = [
  // Visiting card route at root level for maximum priority
  {
    path: 'visiting-card',
    loadChildren: () =>
      import('./features/visiting-card/visiting-card.routes').then((r) => r.visitingCardRoutes),
  },
  {
    path: '',
    children: [
      {
        path: '',
        component: RootSkeletonLayoutComponent,
        children: [
          {
            path: '',
            component: RootHomeSkeletonComponent,
            canActivate: [appRedirectGuard],
          },
        ],
      },
      {
        path: '',
        component: PageLayoutComponent,
        children: [
          {
            path: 'home',
            redirectTo: '',
            pathMatch: 'full',
          },
          {
            path: '',
            loadChildren: () =>
              import('./features/policies/policies.routes').then((r) => r.policiesRoutes),
          },
          {
            path: 'politica-cookies',
            loadComponent: () =>
              import('./features/cookie-policy/cookie-policy.component').then(
                (c) => c.CookiePolicyComponent,
              ),
            title: 'Política de Cookies - D2D',
          },
        ],
      },
    ],
  },
  {
    // Ruta raíz para el callback de OAuth: el backend redirige a /auth/callback sin slug de cliente.
    // Debe ir antes de :client para que 'auth' no sea interpretado como un slug dinámico.
    path: 'auth',
    children: [
      {
        path: 'callback',
        loadComponent: () =>
          import('./features/authentication/pages/oauth-callback/oauth-callback.component').then(
            (m) => m.OAuthCallbackComponent,
          ),
      },
      {
        path: 'error',
        loadComponent: () =>
          import('./features/authentication/pages/oauth-error/oauth-error.component').then(
            (m) => m.OAuthErrorComponent,
          ),
      },
    ],
  },
  {
    path: ':client',
    canActivate: [],
    resolve: { validated: clientSetupResolver, metaConfig: clientMetaResolver },
    children: [
      {
        path: 'auth',
        component: AuthLayoutComponent,
        loadChildren: () =>
          import('./features/authentication/authentication.routes').then(
            (m) => m.authenticationRoutes,
          ),
      },
      {
        path: '',
        component: ClientPageLayoutComponent,
        children: [
          {
            path: '',
            component: HomeComponent,
          },
          {
            path: 'home',
            redirectTo: '',
            pathMatch: 'full',
          },
          {
            path: '',
            loadChildren: () =>
              import('./features/policies/policies.routes').then((r) => r.policiesRoutes),
          },
          {
            path: 'tracking',
            loadComponent: () =>
              import('./features/tracking/tracking.component').then((c) => c.TrackingComponent),
          },
          {
            path: 'tracking/:code',
            loadComponent: () =>
              import('./features/tracking/tracking.component').then((c) => c.TrackingComponent),
          },
          {
            path: 'purchase',
            loadChildren: () =>
              import('./features/purchase-flow/purchase-flow.routes').then(
                (r) => r.purchaseFlowRoutes,
              ),
            data: { hideFooter: true },
          },
          {
            path: 'about-us',
            loadComponent: () =>
              import('./features/about-us/about-us.component').then((c) => c.AboutUsComponent),
          },
          {
            path: 'services',
            loadComponent: () =>
              import('./features/business-services/business-services.component').then(
                (c) => c.BusinessServicesComponent,
              ),
          },
          {
            path: 'help-center',
            loadComponent: () =>
              import('./features/help-center/help-center.component').then(
                (c) => c.HelpCenterComponent,
              ),
          },
          {
            path: 'user',
            loadChildren: () => import('./features/user/user.routes').then((r) => r.userRoutes),
            data: { hideSpeedDial: true },
          },
          {
            path: 'politica-cookies',
            loadComponent: () =>
              import('./features/cookie-policy/cookie-policy.component').then(
                (c) => c.CookiePolicyComponent,
              ),
            title: 'Política de Cookies - D2D',
            data: { hideSpeedDial: true },
          },
          // TODO: traducir código a code
          {
            path: 'tracking/:codigo',
            loadComponent: () =>
              import('./features/tracking/tracking.component').then((c) => c.TrackingComponent),
          },
          {
            path: 'page-not-found',
            component: PageNotFoundComponent,
            data: { hideSpeedDial: true },
          },
          {
            path: '**',
            redirectTo: 'page-not-found',
          },
        ],
      },
    ],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '',
  },
];
